module.exports = __webpack_public_path__ + "static/media/coin.695c294d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/sprites/coin.png
// module id = 993
// module chunks = 0